"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PrivacyCheckbox = ({ checked, disabled, onChange }) => (react_1.default.createElement("button", { "aria-checked": checked ? 'true' : 'false', "aria-disabled": disabled ? 'true' : undefined, className: "privacy__checkbox", onClick: !disabled ? () => onChange(!checked) : undefined, role: "checkbox" }));
exports.default = PrivacyCheckbox;
